import {ConnectedPosition} from '@angular/cdk/overlay';

/**
 * The house geometry for a connected panel: open below the trigger, start- then end-aligned,
 * flipping above when there is no room. Every overlay in the app starts from this list.
 */
export const OVERLAY_POSITIONS: ConnectedPosition[] = [
  {originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top', offsetY: 0},
  {originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top', offsetY: 0},
  {originX: 'start', originY: 'top', overlayX: 'start', overlayY: 'bottom', offsetY: 0},
  {originX: 'end', originY: 'top', overlayX: 'end', overlayY: 'bottom', offsetY: 0},
];

/**
 * The gap every connected panel leaves between itself and its trigger. Applied unconditionally by
 * {@link OverlayPanelDirective} — a panel reads as a surface of its own, never joined to the
 * control that opened it, whether or not that control carries a caret.
 */
export const OVERLAY_GAP = 8;

/**
 * The clearance every connected panel keeps from the viewport edge. Given to CDK as the overlay's
 * viewport margin, so a position counts as fitting only while it stays this far inside the window:
 * a panel near an edge flips to its opposite alignment instead of coming to rest flush against it.
 */
export const OVERLAY_VIEWPORT_MARGIN = 8;

/**
 * {@link OVERLAY_POSITIONS} — or a caller's own list — standing `offset` off the origin instead of
 * flush against it. Derived from whatever list is passed rather than a second hand-written array,
 * so a consumer's own positions get the gap too. The sign follows the direction the panel opens:
 * one attached below the origin's bottom edge is pushed down and away, one flipped above is
 * pushed up.
 */
export function offsetPositions(positions: ConnectedPosition[], offset: number): ConnectedPosition[] {
  return positions.map(position => ({
    ...position,
    offsetY: position.originY === 'bottom' ? offset : -offset,
  }));
}
